import { Table, Space, Button, Row, Col, Input, Select, Modal, Tooltip, Pagination } from "antd";
import { SearchOutlined, FilePdfOutlined, DeleteOutlined } from "@ant-design/icons";
import { CiSquarePlus } from "react-icons/ci";
import React, { useEffect, useState } from "react";
import AddPaymentModal from "./AddPayment";
import { dropdownService, paymentVoucherService, vendorService } from "../../../../../services";
import { Link } from "react-router-dom";
import { changeDocumentTitle } from "../../../../../utils/title";

function PaymentVoucher() {

  const [loading, setLoading] = useState(false);
  const [payments, setPayments] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [search, setSearch] = useState(null)
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [companies, setCompanies] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [banks, setBanks] = useState([]);
  const [isModalShow, setIsModalShow] = useState(false);
  const [isDeleteModal, setDeleteModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [voucherNo, setVoucherNo] = useState(null);

  const showModal = () => setIsModalShow(true);

  const showDeleteModal = (record) => {
    setSelectedRecord(record);
    setDeleteModal(true);
  };

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
    },
    {
      title: "PV Number",
      dataIndex: "voucher_number",
      key: "voucher_number",
    },
    {
      title: "Company",
      dataIndex: "company",
      key: "company",
      render: (text, record) => {
        const company = companies.find((comp) => comp.id === record.company_id);
        return company ? company.name : "Unknown Company";
      },
    },
    {
      title: "Vendor",
      dataIndex: "Vendor",
      key: "Vendor",
      render: (text, record) => {
        const vendor = vendors.find((vendor) => vendor.id === record.vendor_id);
        return vendor ? vendor.name : "Unknown Vendor";
      },
    },
    {
      title: "Total Amount($)",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Action",
      key: "Action",
      render: (text, record, { _id }) => (
        <Space size="small">
          <Link to={`/accounts/payment-vouchers/PDF/${record.voucher_number}`} className="hover:text-primary">
            <Tooltip title='Pdf'>
              <FilePdfOutlined />
            </Tooltip>
          </Link>

          <Tooltip title='Delete'>
            <DeleteOutlined onClick={() => showDeleteModal(record)} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const handleDelete = async () => {
    setLoading(true);
    if (!selectedRecord || !selectedRecord.id) {
      console.error("No payment voucher selected for deletion.");
      return;
    }
    const response = await paymentVoucherService.deletePayment(
      selectedRecord.id
    );

    if (response.success) {
      setPayments((prevData) =>
        prevData.filter((item) => item.id !== selectedRecord.id)
      );
      initialize(pagination.current, pagination.pageSize);
    } else {
      console.error("Failed to delete the customer.");
    }
    setLoading(false);
    setDeleteModal(false);
  };

  const handleCancel = () => {
    setSelectedRecord(null);
    setDeleteModal(false);
  };


  const getCompanies = async () => {
    const response = await dropdownService.fetchCompanies();
    if (response.success) {
      setCompanies(response.data);
    }
  };

  const getVendors = async () => {
    const response = await vendorService.fetchAll();
    if (response.success) {
      setVendors(response.data);
    }
  };

  const getPaymentModes = async () => {
    const response = await dropdownService.fetchPaymentModes();
    if (response.success) {
      setPaymentModes(response.data);
    }
  };

  const getBanks = async () => {
    const response = await dropdownService.fetchBanks();
    if (response.success) {
      setBanks(response.data);
    }
  };

  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await paymentVoucherService.fetch(page, pageSize);
    if (success) {
      setPayments(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setVoucherNo(Number(data.data[0]?.voucher_number) + 1)
    setLoading(false);
  };

  useEffect(() => {
    changeDocumentTitle("Payment Vouchers");
    if (refresh) {
      initialize(pagination.current, pagination.pageSize);
    }
    setRefresh(false)
    getCompanies();
    getVendors();
    getPaymentModes();
    getBanks();
  }, [refresh]);


  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row align="middle" style={{ padding: "10px" }}>
        {/* Left side */}
        <Col xs={24} md={8}>
          <h1 style={{ fontWeight: "bold" }}>Payment Voucher</h1>
        </Col>
        {/* Right side */}
        <Col xs={24} md={16} style={{ textAlign: "right" }}>
          <Space wrap>
            <Button
              type="primary" onClick={showModal}>
              Add Voucher

            </Button>
          </Space>
        </Col>
      </Row>

      <div className="flex justify-end">
        <Input
          placeholder="Search..."
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => {
            setSearch(e.target.value)
          }}
        />
      </div>

      {/* Delete Modal */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isDeleteModal}
        onCancel={handleCancel}
        centered
        styles={{
          body: {
            padding: "20px",
          },
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              onClick={handleDelete}
              style={{ width: "30%" }}
              loading={loading}
            >
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>

      {/* Add Payment Modal */}
      <AddPaymentModal
        visible={isModalShow}
        setIsModalShow={setIsModalShow}
        vendors={vendors}
        companies={companies}
        paymentModes={paymentModes}
        voucherNo={voucherNo}
        setRefresh={setRefresh}
        banks={banks}
      />

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={payments}
        rowKey="id"
        loading={loading}
        style={{ marginTop: "10px" }}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}

export default PaymentVoucher;
